import React, { useState } from 'react';
import { Menu } from 'antd';
import { MenuInfo } from 'rc-menu/lib/interface';

import { RejectModal } from 'leash/pages/details/detailsHeader/RejectModal';

export enum ManualActions {
  RejectedByCustomer = 'customer',
  RejectedByBreeder = 'breeder',
  RejectedByPuppySpot = 'puppyspot',
  Confirmed = 'confirmed',
}

export function ManualActionsMenu() {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectedBy, setRejectedBy] = useState<ManualActions>();

  const onReject = (e: MenuInfo) => {
    setShowRejectModal(true);
    setRejectedBy(e.key as ManualActions);
  };

  return (
    <>
      <RejectModal
        showModal={showRejectModal}
        setShowModal={setShowRejectModal}
        rejectedBy={rejectedBy as ManualActions}
      />
      <Menu>
        <Menu.Item
          data-testid="reject-by-customer"
          key={ManualActions.RejectedByCustomer}
          onClick={onReject}
        >
          Rejected by Customer
        </Menu.Item>
        <Menu.Item
          data-testid="reject-by-breeder"
          key={ManualActions.RejectedByBreeder}
          onClick={onReject}
        >
          Rejected by Breeder
        </Menu.Item>
        <Menu.Item key={ManualActions.RejectedByPuppySpot} onClick={onReject}>
          Rejected by PuppySpot
        </Menu.Item>
      </Menu>
    </>
  );
}
